import { QueryClient } from "@tanstack/react-query";
import { experimental_createPersister } from "@tanstack/react-query-persist-client";
import {
  FIVE_MINUTES_IN_MS,
  TWELVE_HOURS_IN_MS,
  QUERY_CLIENT_PREFIX,
} from "./constants";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // gcTime should be the same or greater than the persister maxAge (https://tanstack.com/query/latest/docs/framework/react/plugins/persistQueryClient#how-it-works)
      gcTime: TWELVE_HOURS_IN_MS,
      staleTime: FIVE_MINUTES_IN_MS,
      persister: experimental_createPersister({
        storage: window.sessionStorage,
        maxAge: TWELVE_HOURS_IN_MS,
        prefix: QUERY_CLIENT_PREFIX,
      }),
    },
  },
});
